import React from 'react';
import autoBind from 'react-autobind';
import { Redirect, Link } from 'react-router-dom';
import feathers from '../../feathers';
import noty from '../../lib/noty';
import Field from '../../components/Field';
import FieldLocation from '../../components/FieldLocation';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { FacilityRecord } from '../../feathers/records';

export default class NewFacility extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      fetching: false,
      facility: new FacilityRecord(),
      redirect: null,
      canAdd: true
    };
  }

  componentDidMount() {
    // Note: check the `Panel` component for a detailed explanation of this logic
    const { checkCanAdd } = this.props;
    if (checkCanAdd) {
      feathers
        .service('api/allowed-resources')
        .find({ query: { scope: checkCanAdd } })
        .then(res => {
          const canAdd = Object.values(res).reduce((canAdd, item) => {
            return canAdd && item.can_add;
          }, true);
          // The page can be redirected before this call returns.
          // Check that it is still mounted before setting state.
          if (this.updater.isMounted(this)) {
            this.setState({ canAdd });
          }
        })
        .catch(err => {
          noty.errors(err);
        });
    }
  }

  handleChange({ name, value }) {
    const path = name.split('.');
    this.setState({ facility: this.state.facility.setIn(path, value) });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { facility } = this.state;
    this.setState({ fetching: true });
    facility
      .create()
      .then(created => {
        noty.success('Facility created.');
        this.setState(
          {
            fetching: false,
            redirect: `/facilities/${created._id}`,
            facility: new FacilityRecord()
          },
          () => {
            this.props.onRequestClose();
          }
        );
      })
      .catch(err => {
        this.setState({ fetching: false });
        noty.errors(err);
      });
  }

  handleClose() {
    this.setState({
      fetching: false,
      redirect: null,
      facility: new FacilityRecord()
    });
    this.props.onRequestClose();
  }

  render() {
    const { fetching } = this.state;
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const { facility } = this.state;
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.handleClose}
        disabled={fetching}
      />
    ];

    if (this.state.canAdd) {
      actions.push(
        <FlatButton
          label="Submit"
          type="submit"
          form="newFacilityForm"
          primary
          onClick={this.handleSubmit}
          disabled={fetching}
        />
      );
    }

    return (
      <Dialog
        actions={actions}
        open={this.props.open}
        contentStyle={{ maxWidth: 600 }}
      >
        <form id="newFacilityForm">
          <div>
            {this.state.canAdd && (
              <div>
                <div className="row">
                  <div className="col-xs-8">
                    <Field
                      name="name"
                      value={facility.name}
                      onChange={this.handleChange}
                      label="Facility Name"
                      disabled={fetching}
                    />
                  </div>
                  <div className="col-xs-4">
                    <Field
                      name="short_name"
                      value={facility.short_name}
                      onChange={this.handleChange}
                      hintText="GA"
                      label="Short Name"
                      disabled={fetching}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    <FieldLocation
                      addressName="address"
                      geoName="geo.coordinates"
                      geoValue={facility.geo.coordinates}
                      value={facility.address}
                      onChange={this.handleChange}
                      label="Facility Location"
                      disabled={fetching}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            {!this.state.canAdd && (
              <div style={{ textAlign: 'center' }}>
                <h3>
                  You have exceeded your limit of allowed{' '}
                  {this.props.checkCanAdd.toUpperCase()}
                </h3>
                <br />
                <RaisedButton
                  label="Click here to change your plan"
                  fullWidth
                  primary
                  onClick={this.handleClose}
                  containerElement={<Link to="/account/settings" />}
                />
              </div>
            )}
          </div>
        </form>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NewFacility/index.jsx